#@export GliveBooking.Presenters.Time

class GliveBooking.Presenters.Time extends BookingV2.Presenters.Base

  module: 'glive-booking'

  timeHash: (momentTime) ->
    hours:   momentTime.format('h')
    minutes: momentTime.format('mm')
    period:  momentTime.format('a')

  isRange: ->
    @collection?.meta('calendar')?.isARSE()

  modelToHash: (model, selection) ->
    id = model.get('id')
    isRange = @isRange()

    from = @timeHash model.get('initialTimeMoment')
    to = @timeHash model.get('finalTimeMoment') if isRange
    selected = selection?.start() == model.start()

    time = {id, isRange, from, to, selected}
    {time}

  toHash: ->
    @modelToHash(@model, @options?.selected) if(@model?)

  bhc: ->
    {from, to, isRange} = @toHash().time
    time = (t) -> "#{t.hours}.#{t.minutes}#{t.period}"
    label = 'time'
    value = time(from)
    if isRange
      label = 'range'
      value = "#{value}-#{time(to)}"
    "#{label}:#{value}"
